export default __webpack_public_path__ + "22f0fd4b6b43d142a47786c2432b2902.jpg";